import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes;

export const SidebarDataTest = [
  {
    tittle: "Nestfin Superadmin",
    icon: "file",
    showAsTab: false,
    separateRoute: false,
    submenuItems: [
      // =========== >>>> Nestfin superadmin <<<< ============
      {
        label: "Organizations",
        link: routes.AllOrganizations,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "organization",
        materialicons: "people",
        submenuItems: [
          {
            label: "Dashboard",
            link: routes.adminDashboard,
            base: "organization",
          },
          {
            label: "Property List",
            link: routes.AllProperty,
            base: "organization",
          },
          {
            label: "Tenants",
            link: routes.tenants,
            base: "organization",
          },
          {
            label: "Bookings",
            link: routes.bookings,
            base: "organization",
          },
          {
            label: "Expenses",
            link: routes.expenses,
            base: "organization",
          },
          {
            label: "Complaints",
            link: routes.complaints,
            base: "organization",
          },

          // {
          //   label: "Leads",
          //   link: routes.leadsList,
          //   base: "organization",
          // },
        ],
      },
      {
        label: "Leads Report",
        link: routes.leadsReport,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "leadsreport",
        materialicons: "people",
        submenuItems: [
          {
            label: "Add Leads",
            link: routes.uploadLeads,
            base: "leadsreport",
          },
          {
            label: "Leads List",
            link: routes.leadsList,
            base: "leadsreport",
          },
          {
            label: "Leads Activity Report",
            link: routes.leadsReport,
            base: "leadsreport",
          },
          {
            label: "Leads Management",
            link: routes.leadsManagement,
            base: "leadsreport",
          },
        ],
      },
      {
        label: "Collection",
        link: routes.collection,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "collection",
        materialicons: "people",
        submenuItems: [
          {
            label: "Dashboard",
            link: routes.dashboardItems,
            base: "dashboard",
          },
          {
            label: "Collection",
            link: routes.paidCollection,
            base: "collection",
          },
          // {
          //   label: "Dues",
          //   link: routes.unPaidCollection,
          //   base: "collection",
          // },
        ],
      },
      {
        label: "Reconciliation",
        link: routes.reconciliation,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "reconciliation",
        materialicons: "people",
        submenuItems: [
          {
            label: "Dashboard",
            link: routes.transectionDashboardItems,
            base: "dashboard",
          },
          {
            label: "Transaction Report",
            link: routes.transactionReport,
            base: "reconciliation",
          },
        ],
      },
      {
        label: "Lead Subscription",
        link: routes.subscription,
        submenu: true,
        showSubRoute: true,
        icon: "users",
        base: "subscription",
        materialicons: "people",
        submenuItems: [
          {
            label: "Basic",
            link: routes.subscriptionExpired,
            base: "subscription",
          },
          {
            label: "Premium",
            link: routes.subscriptionActive,
            base: "subscription",
          },
        ],
      },
    ],
  },
];

// ====== nestfin admin =========
// {
//   label: "Nestfin",
//   link: routes.nestfin,
//   submenu: true,
//   showSubRoute: true,
//   icon: "users",
//   base: "nestfin",
//   materialicons: "people",
//   submenuItems: [
//     {
//       label: "Organizations",
//       link: routes.AllOrganizations,
//       base: "nestfin",
//     },
//   ],
// },
